class DocumentationProgress {

    constructor() {

        this.NOT_STARTED = "NOT_STARTED";
        this.IN_PROCESS = "IN_PROCESS";
        this.COMPLETED = "COMPLETED";

        this.processIcon = Handlebars.compile($("#icoContentInProcess").html());
        this.completedIcon = Handlebars.compile($("#icoContentCompleted").html());

        // IZE-9629: estado del ciclo de tracking REST (sustituye al timer local de 1s y al socket)
        this._updateIntervals = {};
        this._lastUpdateTimestamps = {};

        this._registerVisibilityListener();
    }

    getPathProgress(path, numberOfContents, completedDocuments, monoModeClassDocument) {

        let state = "";
        let percentage = 0;
        const pathUtils = documentationScreenController.documentationPath.getPathUtils();
        const document = documentationScreenController.getDocument(path.document_root.id);
        const documentCompleted = document.completed;
        const hasAssessment = path.assessment && path.assessment.enabled;
        const courseStarted = pathUtils.getIsCourseStarted(path);

        if (path.test.document && path.test.enabled) {

            numberOfContents += 1;

            if (path.test.document && path.test.document.completed) {
                completedDocuments += 1;
            }

        }

        percentage = (completedDocuments / numberOfContents) * 100;

        if (documentCompleted || (hasAssessment && path.assessment.did_it && percentage === 100) || (!hasAssessment && percentage === 100)) {
            state = this.COMPLETED;
        } else if ((hasAssessment && path.assessment.did_it) || (!hasAssessment && (percentage > 0 && percentage < 100)) || (monoModeClassDocument && monoModeClassDocument.read) || (!hasAssessment && courseStarted)) {
            state = this.IN_PROCESS;
        } else {
            state = this.NOT_STARTED;
        }

        return {
            percentage: percentage,
            state: state
        }

    }

    getPathProgressState(document) {
        if(!document.pathData) {
            return {};
        }

        return document.pathData.progressState.state;
    }

    getProgressState(document) {
        if (document.completed) {
            return this.COMPLETED;
        }

        if (document.read && !document.completed) {
            return this.IN_PROCESS;
        }

        return this.NOT_STARTED;
    }

    changeProgressState(document, progressState) {
        // console.log('changeProgressState', document, progressState);

        const docProgress = $('.doc-monitor-progress-icon-' + document.id);
        const docProgressIcon = docProgress.find('.document-progress-state-icon');
        const docProgressText = docProgress.find('.document-progress-state-text');

        switch(progressState) {

            case this.IN_PROCESS:
                document.progressState = this.IN_PROCESS;
                docProgressIcon.replaceWith(this.processIcon({classNames: "document-progress-state-icon"}));
                docProgressText.text(Translator.trans('TR_EN_PROCESO'));
                docProgressText.removeClass("not-started").addClass("in-progress");
                break;

            case this.COMPLETED:
                document.progressState = this.COMPLETED;
                docProgressIcon.replaceWith(this.completedIcon({classNames: "document-progress-state-icon"}));
                docProgressText.text(Translator.trans('TR_COMPLETADO'));
                docProgressText.removeClass("not-started in-progress").addClass("completed");
                break;
        }
    }

    // ------------------------------------------------------------------
    // IZE-9629 — Ciclo genérico de tracking (start/update/stop) contra la
    // nueva API REST de `php-backend-legacy`, en sustitución de Socket.IO
    // + el REST parcial anterior (setDocumentProgress/setDocumentCompleted).
    // ------------------------------------------------------------------

    _registerVisibilityListener() {
        const that = this;

        // Un único listener global (TA-05, versión simplificada respecto a `engage-front`):
        // al volver a foreground, se reinicia el punto de referencia de "última actualización"
        // de cada intervalo activo para no contabilizar de golpe el tiempo pasado en background
        // (BR-002: el time reading debe representar tiempo real dedicado al contenido).
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
                Object.keys(that._updateIntervals).forEach(function (documentId) {
                    that._lastUpdateTimestamps[documentId] = Date.now();
                });
            }
        });
    }

    _getElapsedSinceLastUpdate(documentId) {
        const last = this._lastUpdateTimestamps[documentId] || Date.now();
        return Date.now() - last;
    }

    _startUpdateInterval(documentId) {
        const that = this;

        this._lastUpdateTimestamps[documentId] = Date.now();

        if (this._updateIntervals[documentId]) {
            return;
        }

        this._updateIntervals[documentId] = setInterval(function () {
            // TA-05: no se envía `update` mientras la pestaña está en background.
            if (document.visibilityState !== 'visible') {
                return;
            }

            const elapsedTime = that._getElapsedSinceLastUpdate(documentId);
            that._lastUpdateTimestamps[documentId] = Date.now();

            if (elapsedTime <= 0) {
                return;
            }

            api.updateDocumentTracking(documentId, elapsedTime, function (response) {
                that._handleTrackingResult(documentId, response);
            });
        }, 5000);
    }

    _stopUpdateInterval(documentId) {
        clearInterval(this._updateIntervals[documentId]);
        delete this._updateIntervals[documentId];
        delete this._lastUpdateTimestamps[documentId];
    }

    // Tolerante tanto a string ISO como a objeto \DateTime de PHP serializado ({date, timezone_type, timezone}).
    _parseCompletionDate(completionDate) {
        if (!completionDate) {
            return null;
        }

        if (typeof completionDate === 'string') {
            return completionDate;
        }

        if (completionDate.date) {
            return completionDate.date;
        }

        return null;
    }

    // IZE-9629 (FR-025, TASK-012): wrappers finos sobre el mismo ciclo genérico de tracking
    // (`api.updateDocumentTracking`/`api.stopDocumentTracking`, ya usados por `_startUpdateInterval`/
    // `stopRead`), pero pensados para ser llamados desde un checkpoint de dominio (pregunta
    // respondida en Juego/Test/Encuesta) en vez de desde un `setInterval`. Quien llama decide el
    // `elapsedTime` y cuándo llamar a cuál (ver `PlayScreenController::_trackQuestionCheckpoint`);
    // aquí solo se encapsula la llamada AJAX y la propagación del resultado a la interfaz, igual
    // que el resto del ciclo genérico.
    _trackingUpdate(documentId, elapsedTime) {
        const that = this;

        api.updateDocumentTracking(documentId, elapsedTime, function (response) {
            that._handleTrackingResult(documentId, response);
        });
    }

    _trackingStop(documentId, elapsedTime) {
        const that = this;

        api.stopDocumentTracking(documentId, elapsedTime, function (response) {
            that._handleTrackingResult(documentId, response);
        });
    }

    // Manejo común de la respuesta de start/update/stop/completion (FR-008, FR-009, BR-011).
    // Reutilizado por el resto de flujos de completitud (Juego/Test/Encuesta/Learning Path).
    _handleTrackingResult(documentId, response) {
        const result = response && response.result;

        if (!result) {
            return;
        }

        // `skipped`: el backend no decide la completitud por esta vía (p. ej. `tracking/completion` sobre un
        // Learning Path, modo SPECIAL, que se completa por su propio flujo). No trae `completed`, así que
        // tratarlo como "no completado" degradaría a IN_PROCESS un documento ya completado.
        if (result.skipped) {
            return result;
        }

        const currentDocument = documentationScreenController.getDocument(documentId);

        if (currentDocument) {
            currentDocument.read = result.read;
            currentDocument.completed = result.completed;
            currentDocument.time_reading = result.time_reading;
        }

        if (result.completed) {
            this.markCompletedLocally(documentId, result.points_awarded, this._parseCompletionDate(result.completion_date), !result.was_completed);
        } else if (currentDocument) {
            this.changeProgressState(currentDocument, this.IN_PROCESS);
            this.setContentProgress(documentId, 'IN_PROCESS');
        }

        return result;
    }

    startRead(documentId) {
        // Enlaza los listeners de completitud propios del tipo de documento (scroll, carousel,
        // descarga, reproducción de media...). Para Vídeo/Audio esta llamada es idempotente: el
        // enlace real de sus listeners ya se hizo al abrir el documento (ver DocumentationScreenController.js).
        this.setCompleteness(documentId);

        this._beginTracking(documentId);
    }

    // IZE-9531 (paridad Externo-con-reproductor ~ Vídeo/Audio): arranque real del ciclo de
    // tracking (GET .../tracking + POST .../tracking/start condicionado a read:false), extraído
    // de `startRead` para poder diferirlo hasta el primer `play` — igual que ya hacía
    // `setCompletenessByMedia` para Vídeo/Audio — también en contenido externo con submodo
    // EXTERNAL_BY_PLAYBACK_END (ver `_dispatchExternalMode` y `_bindPlayerjsEndedListener`).
    _beginTracking(documentId) {
        const that = this;

        // La visualización del contenido NO espera a esta llamada (FR-018).
        // Versión simplificada respecto a `engage-front` (ADR-04): se anida la llamada de
        // `start` dentro del éxito de la consulta previa, sin refs ni gestión de cancelación
        // (no hay ciclo de montaje/desmontaje de componente en jQuery).
        api.getDocumentTrackingStatus(
            documentId,
            function (response) {
                const status = response && response.result;

                that._startUpdateInterval(documentId);

                if (status && status.read) {
                    return;
                }

                api.startDocumentTracking(documentId, function (startResponse) {
                    that._handleTrackingResult(documentId, startResponse);
                });
            },
            function () {
                // Si la consulta falla, se asume read:false y se llama a start igualmente (ADR-04).
                that._startUpdateInterval(documentId);
                api.startDocumentTracking(documentId, function (startResponse) {
                    that._handleTrackingResult(documentId, startResponse);
                });
            }
        );
    }

    stopRead(documentId) {
        const that = this;
        const elapsedTime = this._getElapsedSinceLastUpdate(documentId);

        this._stopUpdateInterval(documentId);

        function runReadingCallback() {
            // El antiguo listener de socket `STOP_VIEWING_RESPONSE` disparaba este callback (usado
            // por el scroll de lectura automática, ver DocumentationScroll.js) independientemente
            // del resultado; se conserva el mismo punto de sincronización tras la llamada REST.
            const documentationSockets = documentationScreenController.documentationSockets;
            if (documentationSockets && documentationSockets.callbackReadingFunc) {
                documentationSockets.callbackReadingFunc();
                documentationSockets.callbackReadingFunc = null;
            }
        }

        if (elapsedTime > 0) {
            api.stopDocumentTracking(documentId, elapsedTime, function (response) {
                that._handleTrackingResult(documentId, response);
                runReadingCallback();
            });
        } else {
            runReadingCallback();
        }
    }

    setContentProgress(documentId, progressState = 'IN_PROCESS') {
        // send to zustand (react)

        if(window.reactZustandBridge) {
            window.reactZustandBridge.changeContentProgress(documentId, progressState);
        }
    }

    // Marca un documento como "en progreso" únicamente en la UI (icono + puente react-zustand).
    // Ya no emite ningún evento de socket ni llama al REST parcial: el estado "en progreso" queda
    // reflejado por la propia respuesta de `start`/`update` (ver `_handleTrackingResult`); este
    // método se conserva como punto de entrada público para los dispatchers de completitud
    // (`setCompletenessBy*`) que hoy marcan explícitamente el inicio de la interacción del usuario
    // (reproducir un vídeo, empezar un carrusel, etc.).
    setInProgress(documentId) {
        try {
            this.setContentProgress(documentId, 'IN_PROCESS');
            const currentDocument = documentationScreenController.getDocument(documentId);
            if (currentDocument) {
                this.changeProgressState(currentDocument, this.IN_PROCESS);
            }
        } catch (e) {
            console.error('Error on setInProgress: ', e);
        }
    }

    // Completitud explícita (modo Natural) y completitud incondicional (Encuesta, modo Especial):
    // fuerza la completitud al 100% contra `POST .../tracking/completion` (FR-004, FR-020).
    // No se usa para Juego/Test/Learning Path, que se completan siempre a través de su propio
    // endpoint dedicado (ver DocumentGameResults.js, DocumentTestResults.js, DocumentationPath.js).
    setCompleted(documentId) {
        const that = this;

        // Si el documento ya está completado localmente, no se vuelve a llamar a completion
        // (evita una llamada de red redundante en cada reproducción/interacción posterior; ver TC-VID-08).
        const currentDocument = documentationScreenController.getDocument(documentId);
        if (currentDocument && currentDocument.completed) {
            return;
        }

        api.completeDocumentTracking(documentId, function (response) {
            that._handleTrackingResult(documentId, response);
        });
    }

    // Actualiza la UI (icono, puente react-zustand, celebración de puntos, notificaciones de path)
    // para un documento cuya completitud YA ha sido decidida y persistida por el backend — bien a
    // través de la respuesta de `_handleTrackingResult` (ciclo genérico), bien a través de su propio
    // endpoint dedicado (Juego/Test/Learning Path) — no dispara ninguna llamada adicional de
    // completitud. Sustituye a la celebración que antes disparaba el listener de socket
    // `DOCUMENT_COMPLETED_RESPONSE` (retirado, ver TASK-007). `isNewlyCompleted` evita repetir
    // celebraciones/puntos si el documento ya estaba completado (FR-009, BR-011).
    markCompletedLocally(documentId, points = 0, completionDate = null, isNewlyCompleted = true) {
        this.setContentProgress(documentId, 'COMPLETED');

        const currentDocument = documentationScreenController.getDocument(documentId);

        if (!currentDocument) {
            return;
        }

        this.changeProgressState(currentDocument, this.COMPLETED);
        currentDocument.completed = true;

        if (completionDate) {
            currentDocument.completion_date = completionDate;
        }

        // Habilitar el boton de test del documento
        if (currentDocument.has_test && currentDocument.has_questions) {
            $("#startTestBtn").show();
        }

        if (!isNewlyCompleted) {
            // La completitud puede llegar ya marcada como previa (p. ej. la respuesta que la registró se
            // perdió o llegó después de otra): el path local aún puede no saberlo y dejaría el siguiente
            // contenido bloqueado. Se sincroniza sin celebración ni puntos; es idempotente porque solo
            // actúa si el ítem de la sección aún no consta completado.
            if (currentDocument.isPathClassContent) {
                // `getPathData()` lanza si hay una recarga del path en vuelo (`_pathData` aún nulo, p. ej. al
                // cerrar el contenido); esta sincronización es opcional (la recarga ya trae el estado de
                // backend), así que nunca debe propagar una excepción hacia el callback de la petición.
                try {
                    const documentationPath = documentationScreenController.documentationPath;
                    const sectionItem = documentationPath.getPathUtils().getSectionItem(documentId);

                    if (sectionItem && !sectionItem.completed) {
                        documentationPath.onCompletedClass(currentDocument, 0);
                    }
                } catch (e) {
                    console.error('markCompletedLocally: path sync skipped', e);
                }
            }

            return;
        }

        if (points && world.points_documentation && !currentDocument.isPathClassContent && currentDocument.type !== "PATH") {
            const isCurrentlyOpenDocument =
                documentId === documentationScreenController.documentationScroll.currentReadingDocument ||
                documentId === documentationScreenController.currentDocumentDetails?.id;

            if (isCurrentlyOpenDocument) {
                DocumentationUtils.showPointsModal(points, documentId);
            }
        } else if (currentDocument.isPathClassContent) {
            documentationScreenController.documentationPath.onCompletedClass(currentDocument, points || 0);
        } else if (currentDocument.type === "PATH") {
            documentationScreenController.documentationPath.onCompletedPath();
        }

        // Instagram - update completion status
        const pathWallMode = $(".doc-details-PATH.is-path-wall");
        if (pathWallMode.length > 0 && currentDocument.type !== "PATH") {
            const blockers = documentationScreenController.documentationPath.getPathData().blockers ?? [];

            if (blockers.length > 0) {
                documentationScreenController.documentationPath.unlockNextDocumentPath({
                    pathData: documentationScreenController.documentationPath.getPathData(),
                    currentDocument: currentDocument,
                });
            }
        }
    }

    setCompleteness(documentId) {
        const document = documentationScreenController.getDocument(documentId);

        // console.trace('setCompleteness', {documentId, document});

        // Es posible que el contenido sea el juego/test/encuesta de un path, en este caso no tiene porque estar en la documentacion
        // Documentos con completitud por juegos [GAME, TEST, POLL]
        // Los eventos de SET_IN_PROGRESS y SET_COMPLETED se lanzan al empezar a jugar y terminar de jugar (apicalls)
        if (!document) {
            return;
        }

        if (document.type === "URL") {
            this.setCompletenessByExternal(documentId);
        }

        // Documentos con completitud por talla (Por acceso o tamaño) [URL, PDF, IMAGE, DOC, HTML]
        if (["PDF", "IMAGE", "DOC", "HTML"].indexOf(document.type) >= 0) {
            this.setCompletenessBySize(documentId);
        }

        // Documentos con completitud por reproducción [AUDIO, VIDEO]
        if (["VIDEO", "AUDIO"].indexOf(document.type) >= 0) {
            this.setCompletenessByMedia(documentId);
        }

        // Documentos con completitud por carousel [GALLERY]
        if (document.type === "GALLERY") {
            this.setCompletenessByCarousel(documentId);
        }

        // Documentos con completitud por descarga [ZIP]
        if (document.type === "ZIP") {
            this.setCompletenessByDownload(documentId);
        }

        // Documentos con completitud por scroll [ARTICLE]
        if (document.type === "ARTICLE") {
            this.setCompletenessByScroll(documentId);
        }

    }

    // IZE-9629 (FR-022, TASK-008) — Contenido externo [URL]: el backend resuelve, en cascada,
    // uno de cuatro submodos propios y exclusivos de este tipo (contrato T-019), devueltos en
    // el campo `mode` de `GET .../tracking`. Sustituye a la inspección en cliente de
    // `content_external.rel`/`document.external` que se usaba hasta ahora.
    setCompletenessByExternal(documentId) {
        const that = this;

        api.getDocumentTrackingStatus(
            documentId,
            function (response) {
                const status = response && response.result;
                that._dispatchExternalMode(documentId, status && status.mode);
            },
            function () {
                // Si la consulta de estado falla, se aplica el mismo fallback de compatibilidad
                // que un `mode` no reconocido (ver `_dispatchExternalMode`).
                that._dispatchExternalMode(documentId, null);
            }
        );
    }

    // `mode` es uno de EXTERNAL_BY_CONFIRMATION | EXTERNAL_BY_PLAYBACK_END | EXTERNAL_BY_TIME |
    // EXTERNAL_BY_ACCESS (T-019). La ventana nueva gana siempre al reproductor: con
    // EXTERNAL_BY_CONFIRMATION no se engancha ningún listener de playerjs, aunque el
    // contenido también lo tenga.
    _dispatchExternalMode(documentId, mode) {
        switch (mode) {

            case 'EXTERNAL_BY_CONFIRMATION':
                this.setInProgress(documentId);
                this.completeOnCloseNewWindow(documentId);
                this._beginTracking(documentId);
                break;

            case 'EXTERNAL_BY_PLAYBACK_END':
                // IZE-9531 (paridad con Vídeo/Audio, FR-021): a diferencia del resto de submodos
                // externos, aquí NO se llama a `_beginTracking` en este punto — se difiere hasta
                // el primer evento `play` del reproductor embebido (ver `_bindPlayerjsEndedListener`),
                // igual que Vídeo/Audio difieren su `startRead` hasta el `play` nativo.
                this._attachPlayerjsListener(documentId);
                break;

            case 'EXTERNAL_BY_TIME':
            case 'EXTERNAL_BY_ACCESS':
                // Sin lógica propia: la completitud la decide el backend en la respuesta del
                // propio ciclo genérico (start/update/stop), igual que Por tiempo/Por acceso
                // para el resto de tipos.
                this.setInProgress(documentId);
                this._beginTracking(documentId);
                break;

            default:
                // `mode` no reconocido — p. ej. el valor genérico `BY_ACCESS`, mientras el
                // contrato T-019 no esté desplegado en backend (ver `technical-context.md`).
                // No se compara literalmente contra esa cadena: cualquier valor fuera de los
                // cuatro submodos anteriores cae aquí y se resuelve con el mismo criterio que
                // se usaba antes de esta tarea, para no perder el comportamiento ya validado
                // en producción durante la transición.
                this._dispatchExternalModeLegacyFallback(documentId);
                break;
        }
    }

    _dispatchExternalModeLegacyFallback(documentId) {
        const currentDocument = documentationScreenController.getDocument(documentId);

        if (!currentDocument) {
            return;
        }

        const hasPlayerjs = currentDocument.content_external && currentDocument.content_external.rel.indexOf("playerjs") >= 0;

        if (hasPlayerjs && !currentDocument.external) {
            // Mismo criterio de diferimiento que EXTERNAL_BY_PLAYBACK_END: no se llama a
            // `_beginTracking` aquí, se difiere al primer `play` (ver `_bindPlayerjsEndedListener`).
            this._attachPlayerjsListener(documentId);
            return;
        }

        this.setCompletenessBySize(documentId);
        this._beginTracking(documentId);
    }

    // Buffer/margen sobre el `ended` del playerjs (mismo criterio que el buffer de 5s ya usado
    // para VIDEO/AUDIO, ver `setCompletenessByMedia`): sin él, un vídeo que no emita el evento
    // no se completaría nunca. El enganche del listener espera con un `MutationObserver` a que
    // el iframe exista en el DOM, en vez de asumir un tiempo fijo de renderizado (antes,
    // `setTimeout(300ms)`).
    _attachPlayerjsListener(documentId) {
        const that = this;

        this.setInProgress(documentId);

        function tryAttach() {
            const iframes = $('div.external iframe');

            if (iframes.length <= 0) {
                return false;
            }

            that._bindPlayerjsEndedListener(documentId, iframes[0]);
            return true;
        }

        if (tryAttach()) {
            return;
        }

        const container = $('div.external')[0] || window.document.body;
        const observer = new MutationObserver(function () {
            if (tryAttach()) {
                observer.disconnect();
            }
        });

        observer.observe(container, {childList: true, subtree: true});
    }

    _bindPlayerjsEndedListener(documentId, iframeEl) {
        const that = this;
        const currentDocument = documentationScreenController.getDocument(documentId);
        const player = new playerjs.Player(iframeEl);

        // Duración real del reproductor (content_external.duration, en milisegundos aunque el
        // campo se llame `durationSecs`): una talla de tiempo configurada no se aplica cuando
        // el contenido tiene playerjs, el tiempo esperado es siempre la duración del vídeo.
        const durationMs = currentDocument && currentDocument.content_external && currentDocument.content_external.duration;
        const PLAYBACK_END_BUFFER_MS = 5000;

        let completed = false;
        let bufferTimer = null;
        // IZE-9531 (paridad completa con Vídeo/Audio, TC-VID-11/TC-AUD-11): el buffer debe medir
        // tiempo de REPRODUCCIÓN real, no tiempo de reloj transcurrido desde el `ready` — igual
        // que el buffer nativo se basa en `mediaEl.currentTime` (que no avanza en pausa), no en
        // un `setTimeout` fijo. Como el protocolo player.js no expone aquí un equivalente síncrono
        // a `currentTime`, se aproxima llevando la cuenta del margen restante y pausando/reanudando
        // el propio `setTimeout` en cada evento play/pause (detectado en pruebas manuales: sin
        // esto, pausar un vídeo externo a mitad no impedía que el buffer lo completara igualmente
        // por tiempo real transcurrido).
        let bufferRemainingMs = durationMs > 0 ? durationMs + PLAYBACK_END_BUFFER_MS : null;
        let bufferStartedAt = null;

        function complete() {
            if (completed) {
                return;
            }

            completed = true;
            clearTimeout(bufferTimer);
            that.setCompleted(documentId);
        }

        function startBufferTimer() {
            // Guarda idempotente (mismo patrón que `_startUpdateInterval`): algunos reproductores
            // (confirmado con YouTube vía player.js/iframely) emiten más de un evento `play` para
            // una misma reproducción real (p. ej. buffering). Sin esta guarda, cada `play` extra
            // armaba un `setTimeout` adicional sin cancelar el anterior — el primero quedaba
            // huérfano corriendo en segundo plano y `pauseBufferTimer` nunca llegaba a cancelarlo,
            // completando el contenido por tiempo real aunque el usuario hubiera pausado.
            if (completed || bufferRemainingMs === null || bufferTimer !== null) {
                return;
            }

            bufferStartedAt = Date.now();
            bufferTimer = setTimeout(complete, bufferRemainingMs);
        }

        function pauseBufferTimer() {
            if (bufferTimer === null) {
                return;
            }

            clearTimeout(bufferTimer);
            bufferTimer = null;

            if (bufferStartedAt !== null) {
                bufferRemainingMs = Math.max(0, bufferRemainingMs - (Date.now() - bufferStartedAt));
                bufferStartedAt = null;
            }
        }

        player.on('ready', function () {
            // IZE-9531 (paridad con Vídeo/Audio, FR-021): igual que `play.completeness` en
            // `setCompletenessByMedia`, se llama a `_beginTracking` en CADA `play` (no solo el
            // primero) — no es solo el disparador del `start` diferido, también es quien reactiva
            // el `setInterval` de `update` tras una pausa (`_startUpdateInterval` se ejecuta
            // siempre dentro de `_beginTracking`, antes de comprobar `read`). Reservar la llamada
            // solo para el primer `play` dejaba el `update` sin reanudar tras pausar y reproducir
            // de nuevo (detectado en pruebas manuales, TC-EXTVID-04). El propio `_beginTracking`
            // ya es idempotente respecto al `POST start` gracias a su comprobación de `read`.
            player.on('play', function () {
                that.setInProgress(documentId);
                that._beginTracking(documentId);
                startBufferTimer();
            });

            // IZE-9531 (paridad completa con Vídeo/Audio, TC-VID-03/04/09): la pausa del
            // reproductor embebido detiene el ciclo de tracking (stop), igual que
            // `pause.completeness` en `setCompletenessByMedia`. Reanudar con otro `play` no
            // repite el `POST start` (ver comprobación de `read` en `_beginTracking`).
            player.on('pause', function () {
                that.stopRead(documentId);
                pauseBufferTimer();
            });

            player.on('ended', complete);

            // El buffer NO se arma aquí: se difiere al primer `play` (startBufferTimer), igual
            // que el propio `_beginTracking` — antes de reproducir no hay nada que "acumular".
        });
    }

    setCompletenessBySize(documentId) {

        const document = documentationScreenController.getDocument(documentId);
        const openInNewWindow = document.external;
        const folderModeView = documentationScreenController.folderModeView;

        if (openInNewWindow) {
            if (document.type === "IMAGE") {
                if (folderModeView === 'advanced') {

                    this.setCompleted(documentId);

                } else {

                    this.setInProgress(documentId);
                    this.completeOnCloseNewWindow(documentId);

                }

            } else {

                this.setInProgress(documentId);
                this.completeOnCloseNewWindow(documentId);

            }

        } else {

            // IZE-9629 (FR-020): la completitud "por acceso" y "por tiempo" las decide siempre el
            // backend a partir de la respuesta de `start`/`update` (ver `_handleTrackingResult`,
            // ya invocado desde `startRead`). Ya no se marca `setCompleted` ni se arranca ningún
            // timer local aquí: basta con reflejar el estado "en progreso" mientras se resuelve.
            this.setInProgress(documentId);

        }

    }

    setCompletenessByMedia(documentId) {

        let media = null;
        const that = this;
        const document = documentationScreenController.getDocument(documentId);
        const openInNewWindow = document.external;
        const folderModeView = documentationScreenController.folderModeView;

        // Buffer de 5s (TC-VID-11/TC-AUD-11): completa al quedar <=5s para el final sin depender
        // en exclusiva del evento `ended` (que en algunos reproductores/casos no llega a disparar).
        // `bufferTriggered` evita llamar a `setCompleted` en cada tick de `timeupdate` (se dispara
        // muy frecuentemente) mientras la respuesta de completitud todavía está en vuelo.
        const END_BUFFER_SECONDS = 5;
        let bufferTriggered = false;

        function bindMediaCompletenessEvents($media) {
            // IZE-9629 (FR-021): en Vídeo/Audio, el inicio y el cierre de seguimiento se atan al
            // estado de reproducción, no al ciclo de vida del documento (ver DocumentationScreenController.js,
            // que ya NO llama a `startRead` genéricamente para estos dos tipos).
            $media.off("play.completeness").on("play.completeness", function() {
                bufferTriggered = false;
                that.startRead(documentId);
                that.setInProgress(documentId);
            });

            $media.off("pause.completeness").on("pause.completeness", function() {
                that.stopRead(documentId);
            });

            $media.off("timeupdate.completeness").on("timeupdate.completeness", function() {
                const mediaEl = this;
                const remaining = mediaEl.duration - mediaEl.currentTime;

                if (bufferTriggered || !isFinite(remaining) || remaining > END_BUFFER_SECONDS) {
                    return;
                }

                bufferTriggered = true;
                that.setCompleted(documentId);
            });

            $media.off("ended.completeness").on("ended.completeness", function() {
                bufferTriggered = true;
                that.stopRead(documentId);
                that.setCompleted(documentId);
            });
        }

        if (folderModeView === 'advanced') {
            media = $(".documentation-advanced-documents-row[data-document='" + documentId + "']").find(".media-document");
            bindMediaCompletenessEvents(media);
        } else {

            if (openInNewWindow) {

                this.setInProgress(documentId);
                this.completeOnCloseNewWindow(documentId)

            } else {

                media = $(".media-document");
                bindMediaCompletenessEvents(media);

            }

        }

    }

    setCompletenessByCarousel(documentId) {

        let carousel = null;
        const that = this;
        const folderModeView = documentationScreenController.folderModeView;

        this.setInProgress(documentId);

        if (folderModeView === 'advanced') {
            carousel = $(".owl-carousel-advanced[data-document='" + documentId + "']");
        } else {
            carousel = $(".owl-carousel-details[data-document='" + documentId + "']");
        }

        if(!carousel.length) {
            carousel = $(".owl-carousel-advanced[data-document='" + documentId + "']");
        }

        carousel.off('changed.owl.carousel.completeness').on('changed.owl.carousel.completeness', function(event) {
            if (event.item.index + 1 === event.item.count) {
                that.setCompleted(documentId);
            }
        });

    }

    setCompletenessByDownload(documentId) {

        const that = this;

        this.setInProgress(documentId);

        $(".openExternalDocumentButton").off("click.downloadDocument").on("click.downloadDocument", function() {
            that.setCompleted(documentId);
        });

    }

    setCompletenessByScroll(documentId) {
        if (this.completeScrollFunction) {
            window.removeEventListener("message", this.completeScrollFunction, true);
        }

        this.completeScrollFunction = function (event) {
            try {
                const origin = event.origin;
                let iframeUrl = '';

                if(URL) {
                    iframeUrl = (new URL($(".doc-details-ARTICLE").attr("src"))?.origin) ?? null;
                }
                const eventData = event.data;

                if (origin === iframeUrl && eventData === "article_bottom") {
                    that.setCompleted(document.id);
                }
            } catch (e) {
                console.error(e);
            }
        }

        const that = this;
        const document = documentationScreenController.getDocument(documentId);
        const openInNewWindow = document.external;

        if (openInNewWindow) {

            this.setInProgress(documentId);
            this.completeOnCloseNewWindow(documentId);

        } else {

            this.setInProgress(documentId);
            window.addEventListener("message", this.completeScrollFunction, true);

        }

    }

    completeOnCloseNewWindow(documentId) {

        const that = this;

        $(".doc-details-external-box-button").off("click.external").on("click.external", function() {

            swal({
                title: "",
                text: Translator.trans("TR_CONTENIDO_ABIERTO"),
                closeOnConfirm: true,
                allowEscapeKey : false
            }, function() {
                that.setCompleted(documentId);
            });

        });

    }

}
